(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  const roots = document.querySelectorAll('.bbp');
  roots.forEach(initBbp);

  function initBbp(root) {
    const minQty = parseInt(root.dataset.min, 10) || 1;
    const currency = root.dataset.currency || 'USD';
    const locale = root.dataset.locale || 'en';

    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
    });
    const formatMoney = (cents) => formatter.format((cents || 0) / 100);

    const state = {};
    let activeTier = { planId: '', discountType: '', discountValue: 0 };

    const countEl = root.querySelector('.bbp-count');
    const totalEl = root.querySelector('.bbp-total-amount');
    const totalOriginalEl = root.querySelector('.bbp-total-original');
    const subInfoEl = root.querySelector('.bbp-subscription-info');
    const subAmountEl = root.querySelector('.bbp-sub-amount');
    const addBtn = root.querySelector('.bbp-add-to-cart');
    const errorEl = root.querySelector('.bbp-error');
    const tierBtns = root.querySelectorAll('.bbp-tier');
    const itemEls = root.querySelectorAll('.bbp-item');

    const totalQty = () =>
      Object.values(state).reduce((sum, item) => sum + item.qty, 0);

    const subtotal = () =>
      Object.values(state).reduce((sum, item) => sum + item.qty * item.price, 0);

    const applyDiscount = (cents) => {
      if (!activeTier.discountType || activeTier.discountValue <= 0) return cents;
      if (activeTier.discountType === 'percentage') {
        return Math.round(cents * (1 - activeTier.discountValue / 100));
      }
      if (activeTier.discountType === 'fixed_amount') {
        return Math.max(0, cents - activeTier.discountValue);
      }
      return cents;
    };

    const renderItemPrices = () => {
      itemEls.forEach((itemEl) => {
        const price = parseInt(itemEl.dataset.price, 10) || 0;
        const discounted = applyDiscount(price);
        const discEl = itemEl.querySelector('[data-discounted-price]');
        const origEl = itemEl.querySelector('[data-original-price]');
        if (discounted < price) {
          discEl.textContent = formatMoney(discounted);
          origEl.textContent = formatMoney(price);
          origEl.hidden = false;
        } else {
          discEl.textContent = formatMoney(price);
          origEl.hidden = true;
        }
      });
    };

    const render = () => {
      const qty = totalQty();
      const sub = subtotal();
      const discounted = applyDiscount(sub);
      const savings = sub - discounted;

      countEl.textContent = qty;

      if (qty === 0) {
        totalEl.textContent = '—';
        totalOriginalEl.hidden = true;
        subInfoEl.hidden = true;
      } else {
        totalEl.textContent = formatMoney(discounted);
        if (savings > 0) {
          totalOriginalEl.textContent = formatMoney(sub);
          totalOriginalEl.hidden = false;
          subAmountEl.textContent = `−${formatMoney(savings)}`;
          subInfoEl.hidden = false;
        } else {
          totalOriginalEl.hidden = true;
          subInfoEl.hidden = true;
        }
      }

      addBtn.disabled = qty < minQty;
      addBtn.textContent = qty < minQty
        ? `Choisis encore ${minQty - qty} savon${minQty - qty > 1 ? 's' : ''}`
        : 'Ajouter au panier';

      itemEls.forEach((itemEl) => {
        const id = itemEl.dataset.variantId;
        const value = (state[id] && state[id].qty) || 0;
        itemEl.querySelector('.bbp-qty-value').textContent = value;
        itemEl.querySelector('.bbp-qty-minus').disabled = value === 0;
        itemEl.classList.toggle('is-active', value > 0);
      });

      renderItemPrices();
    };

    const updateQty = (itemEl, delta) => {
      const id = itemEl.dataset.variantId;
      if (!state[id]) {
        state[id] = {
          qty: 0,
          price: parseInt(itemEl.dataset.price, 10) || 0,
          title: itemEl.dataset.title,
          image: itemEl.dataset.image,
        };
      }
      state[id].qty = Math.max(0, state[id].qty + delta);
      if (state[id].qty === 0) delete state[id];
      render();
    };

    root.addEventListener('click', (e) => {
      const plus = e.target.closest('.bbp-qty-plus');
      const minus = e.target.closest('.bbp-qty-minus');
      const tierBtn = e.target.closest('.bbp-tier');

      if (plus) updateQty(plus.closest('.bbp-item'), 1);
      if (minus) updateQty(minus.closest('.bbp-item'), -1);
      if (tierBtn) {
        tierBtns.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-checked', 'false');
        });
        tierBtn.classList.add('is-active');
        tierBtn.setAttribute('aria-checked', 'true');
        activeTier = {
          planId: tierBtn.dataset.plan || '',
          discountType: tierBtn.dataset.discountType || '',
          discountValue: parseFloat(tierBtn.dataset.discountValue) || 0,
        };
        render();
      }
    });

    addBtn.addEventListener('click', async () => {
      errorEl.hidden = true;
      const items = Object.entries(state)
        .filter(([, item]) => item.qty > 0)
        .map(([id, item]) => {
          const payload = { id: parseInt(id, 10), quantity: item.qty };
          if (activeTier.planId) payload.selling_plan = parseInt(activeTier.planId, 10);
          return payload;
        });
      if (items.length === 0) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Ajout en cours…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Erreur lors de l\'ajout au panier.');
        }
        window.location.href = '/cart';
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
        addBtn.disabled = false;
        addBtn.textContent = 'Ajouter au panier';
      }
    });

    render();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.querySelector('.bundle-builder');
  if (!root) return;

  const minQty = parseInt(root.dataset.min, 10) || 1;
  const currency = root.dataset.currency || 'USD';
  const locale = root.dataset.locale || 'en';

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  });

  const formatMoney = (cents) => formatter.format((cents || 0) / 100);

  const state = {};
  let activeTier = {
    planId: '',
    discountType: '',
    discountValue: 0,
  };

  const countEl = root.querySelector('.bb-count');
  const mobileCountEl = root.querySelector('.bb-mobile-count');
  const totalEl = root.querySelector('.bb-total-amount');
  const totalOriginalEl = root.querySelector('.bb-total-original');
  const subInfoEl = root.querySelector('.bb-subscription-info');
  const subAmountEl = root.querySelector('.bb-sub-amount');
  const selectedListEl = root.querySelector('.bb-selected');
  const addBtn = root.querySelector('.bb-add-to-cart');
  const errorEl = root.querySelector('.bb-error');
  const panel = root.querySelector('.bb-panel');
  const mobileToggle = root.querySelector('.bb-mobile-toggle');
  const tierBtns = root.querySelectorAll('.bb-tier');

  const totalQty = () =>
    Object.values(state).reduce((sum, item) => sum + item.qty, 0);

  const subtotal = () =>
    Object.values(state).reduce((sum, item) => sum + item.qty * item.price, 0);

  const applyDiscount = (cents) => {
    if (!activeTier.discountType || activeTier.discountValue <= 0) return cents;
    if (activeTier.discountType === 'percentage') {
      return Math.round(cents * (1 - activeTier.discountValue / 100));
    }
    if (activeTier.discountType === 'fixed_amount') {
      return Math.max(0, cents - activeTier.discountValue);
    }
    return cents;
  };

  const render = () => {
    const qty = totalQty();
    const sub = subtotal();
    const discounted = applyDiscount(sub);
    const savings = sub - discounted;

    countEl.textContent = qty;
    if (mobileCountEl) mobileCountEl.textContent = qty;

    if (qty === 0) {
      totalEl.textContent = '—';
      totalOriginalEl.hidden = true;
      subInfoEl.hidden = true;
    } else {
      totalEl.textContent = formatMoney(discounted);
      if (savings > 0) {
        totalOriginalEl.textContent = formatMoney(sub);
        totalOriginalEl.hidden = false;
        subAmountEl.textContent = `−${formatMoney(savings)}`;
        subInfoEl.hidden = false;
      } else {
        totalOriginalEl.hidden = true;
        subInfoEl.hidden = true;
      }
    }

    selectedListEl.innerHTML = '';
    Object.entries(state).forEach(([variantId, item]) => {
      if (item.qty <= 0) return;
      const li = document.createElement('li');
      li.innerHTML = `
        <img src="${item.image || ''}" alt="">
        <div class="bb-selected-info">
          <p class="bb-selected-title">${item.title}</p>
          <p class="bb-selected-meta">Qté ${item.qty} · ${formatMoney(item.qty * item.price)}</p>
        </div>
        <button type="button" class="bb-selected-remove" data-remove="${variantId}" aria-label="Retirer">×</button>
      `;
      selectedListEl.appendChild(li);
    });

    addBtn.disabled = qty < minQty;
    addBtn.textContent = qty < minQty
      ? `Choisis encore ${minQty - qty} savon${minQty - qty > 1 ? 's' : ''}`
      : 'Ajouter au panier';

    root.querySelectorAll('.bb-qty').forEach((qtyEl) => {
      const id = qtyEl.dataset.variantId;
      const value = (state[id] && state[id].qty) || 0;
      qtyEl.querySelector('.bb-qty-value').textContent = value;
      qtyEl.querySelector('.bb-qty-minus').disabled = value === 0;
      qtyEl.closest('.bb-card').classList.toggle('is-active', value > 0);
    });
  };

  const updateQty = (qtyEl, delta) => {
    const id = qtyEl.dataset.variantId;
    if (!state[id]) {
      state[id] = {
        qty: 0,
        price: parseInt(qtyEl.dataset.price, 10) || 0,
        title: qtyEl.dataset.title,
        image: qtyEl.dataset.image,
      };
    }
    state[id].qty = Math.max(0, state[id].qty + delta);
    if (state[id].qty === 0) delete state[id];
    render();
  };

  root.addEventListener('click', (e) => {
    const plus = e.target.closest('.bb-qty-plus');
    const minus = e.target.closest('.bb-qty-minus');
    const removeBtn = e.target.closest('[data-remove]');
    const tierBtn = e.target.closest('.bb-tier');

    if (plus) updateQty(plus.closest('.bb-qty'), 1);
    if (minus) updateQty(minus.closest('.bb-qty'), -1);
    if (removeBtn) {
      const id = removeBtn.dataset.remove;
      delete state[id];
      render();
    }
    if (tierBtn) {
      tierBtns.forEach((b) => {
        b.classList.remove('is-active');
        b.setAttribute('aria-checked', 'false');
      });
      tierBtn.classList.add('is-active');
      tierBtn.setAttribute('aria-checked', 'true');
      activeTier = {
        planId: tierBtn.dataset.plan || '',
        discountType: tierBtn.dataset.discountType || '',
        discountValue: parseFloat(tierBtn.dataset.discountValue) || 0,
      };
      render();
    }
  });

  if (mobileToggle && panel) {
    mobileToggle.addEventListener('click', () => {
      panel.classList.add('is-open');
      mobileToggle.setAttribute('aria-expanded', 'true');
    });
  }

  addBtn.addEventListener('click', async () => {
    errorEl.hidden = true;
    const items = Object.entries(state)
      .filter(([, item]) => item.qty > 0)
      .map(([id, item]) => {
        const payload = { id: parseInt(id, 10), quantity: item.qty };
        if (activeTier.planId) payload.selling_plan = parseInt(activeTier.planId, 10);
        return payload;
      });

    if (items.length === 0) return;

    addBtn.disabled = true;
    addBtn.textContent = 'Ajout en cours…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Erreur lors de l\'ajout au panier.');
      }
      window.location.href = '/cart';
    } catch (err) {
      errorEl.textContent = err.message;
      errorEl.hidden = false;
      addBtn.disabled = false;
      addBtn.textContent = 'Ajouter au panier';
    }
  });

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
